<template>
    <rkm-tabs
        :tab-refs="tabRefs"
        v-model="tabIndex"
    >
        <rkm-tab
            active
            title="Requisição"
        >
            <Requisicao
                :data="data.requisicao"
                ref="Requisicao"
            />
        </rkm-tab>

        <rkm-tab title="Controle de estoque (Grupos)">
            <ControleEstoque
                :data="data.controleEstoque"
                ref="ControleEstoque"
            />
        </rkm-tab>

        <rkm-tab title="Dispensação de materiais (Grupos)">
            <DispensacaoMateriais
                :data="data.dispensacaoMateriais"
                ref="DispensacaoMateriais"
            />
        </rkm-tab>

        <rkm-tab title="Estoque mínimo/máximo">
            <Estoque
                :data="data"
                ref="Estoque"
            />
        </rkm-tab>

        <rkm-tab title="Portal de divulgação">
            <Portal
                :data="data.portalDivulgacao"
                ref="Portal"
            />
        </rkm-tab>
    </rkm-tabs>
</template>

<script>
// Components.
import Requisicao from './components/requisicao/Form'
import ControleEstoque from './components/controle-estoque/Index'
import DispensacaoMateriais from './components/dispensacao-materiais/Index'
import Estoque from './components/estoque/Index'
import Portal from './components/portal-divulgacao/Index'

export default {
    components: { Requisicao, ControleEstoque, DispensacaoMateriais, Estoque, Portal },
    data: () => ({
        tabIndex: 0,
        tabRefs: [],
    }),
    methods: {
        async validate() {

            const currentValid = await this.tabRefs[this.tabIndex].validate()

            if (!currentValid) {

                return false;
            }

            let valid = true

            for (let i = 0; i < this.tabRefs.length; i++) {

                if (i !== this.tabIndex) {

                    valid = await this.tabRefs[i].validate()

                    if (!valid) {

                        this.tabIndex = i

                        break
                    }
                }
            }

            return valid
        },
    },
    mounted() {

        this.tabRefs = [
            this.$refs.Requisicao,
            this.$refs.ControleEstoque,
            this.$refs.DispensacaoMateriais,  
            this.$refs.Estoque,
            this.$refs.Portal,
        ]
    },
    props: {
        data: { type: Object, required: true },
    }
}
</script>